import {
  getMonth,
  getYear
} from 'date-fns';

// UTC to local date formatting
import { useDates } from '../hooks/UseDates';

interface UseSystemInterface {
  getCurrentFiscalYear: () => string;
  getCurrentFiscalYearEndDate: () => string;
  getCurrentFiscalYearStartDate: () => string;
  getFiscalYearEndDate: (year: number) => string;
  getFiscalYearStartDate: (year: number) => string;
}

export const useSystem = (): UseSystemInterface => {

  const { dateFormatted } = useDates();

  /*
   * Get the last day of the fiscal year (4/30/yyyy)
   */
  const getCurrentFiscalYear = (): string => {
    const now = new Date();
    const month = getMonth(now); // Month 0-11

    if (month <= 3) {
      // Current year and convert the resulting number to a string
      return (now.getFullYear() ).toString();
    } else {
      // Add 1 to the current year and convert the resulting number to a string
      return (now.getFullYear() + 1).toString();
    }

  }

  /*
   * Get the last day of the fiscal year (4/30/yyyy)
   */
  const getCurrentFiscalYearEndDate = (): string => {

    const now = new Date();
    const month = getMonth(now); // Month 0-11

    if (month <= 3) {
      return dateFormatted(new Date(getYear(now), 3, 30));
    } else {
      return dateFormatted(new Date((getYear(now) + 1), 3, 30));
    }

  }

  /*
   * Get the last day of the fiscal year (4/30/yyyy)
   */
  const getFiscalYearEndDate = (year: number): string => {
      return dateFormatted(new Date(year, 3, 30));
  }

  /*
   * Get the first day of the fiscal year (5/1/yyyy)
   */
  const getCurrentFiscalYearStartDate = (): string => {

    const now = new Date();
    const month = getMonth(now); // Month 0-11

    if (month <= 3) {
      return dateFormatted(new Date((getYear(now) - 1), 4, 1));
    } else {
      return dateFormatted(new Date(getYear(now), 4, 1));
    }

  }

  /*
   * Get the first day of the fiscal year (5/1/yyyy)
   */
  const getFiscalYearStartDate = (year: number): string => {
      return dateFormatted(new Date((year - 1), 4, 1));
  }

  return {
    getCurrentFiscalYear,
    getCurrentFiscalYearEndDate,
    getCurrentFiscalYearStartDate,
    getFiscalYearEndDate,
    getFiscalYearStartDate
  };
}